import React, { useRef, useEffect } from 'react';
import '../assets/styles/ClientReviews.scss';
import { FaStar } from 'react-icons/fa';
import { SiFiverr, SiUpwork } from 'react-icons/si';

interface Review {
    id: number;
    name: string;
    country: string;
    review: string;
    rating: number;
    platform: 'fiverr' | 'upwork';
}

const row1Reviews: Review[] = [
    { id: 1, name: "op2metrie", country: "Switzerland", review: "He is always perfect. One of the best on Fiverr I've ever known.", rating: 5, platform: 'fiverr' },
    { id: 2, name: "tareqkasabi", country: "Jordan", review: "Professional, polite and cooperative. I highly recommend working with Ameer.", rating: 5, platform: 'fiverr' },
{ id: 4, name: "cain_smn", country: "France", review: "Did a great job! I recommend! Great work overall.", rating: 5, platform: 'fiverr' },
    { id: 5, name: "kastu12", country: "Saudi Arabia", review: "I had an amazing experience with Ameer. The product was exactly as described. He was very responsive and provided excellent customer service. Highly recommend!", rating: 5, platform: 'fiverr' },
    { id: 6, name: "yanu4412", country: "Switzerland", review: "Ameer programmed a great Android app with an appealing design. Revisions were handled in no time. Communication was very good. I will contact him again for future projects.", rating: 5, platform: 'fiverr' },
    { id: 7, name: "emmilili", country: "Bolivia", review: "I'm beyond grateful to Ameer. He completed everything I asked in a few days, understood all my requirements and completed it successfully. Top-notch development!", rating: 5, platform: 'fiverr' },
    { id: 8, name: "koppaplc", country: "Ethiopia", review: "By far the greatest developer I've ever dealt with. He provided my android app with pinpoint accuracy at a very quick rate. He always keeps you updated on the status. 10/10!", rating: 5, platform: 'fiverr' },
    { id: 9, name: "stefanmller645", country: "Germany", review: "Outstanding experience. Outstanding skills. He developed the app very carefully which is really good looking. I will work with him again in the future!", rating: 5, platform: 'fiverr' },
    { id: 10, name: "khushiun", country: "India", review: "I'm very satisfied and happy with his work and how quick he was! 10/10. This was my first experience on Fiverr and I'm glad I found the right person. Loved his work!", rating: 5, platform: 'fiverr' },
    { id: 11, name: "itszxi", country: "United Kingdom", review: "Really great experience — my second order. He knows what he is doing. Professional, experienced, friendly and active. One of the best on Fiverr.", rating: 5, platform: 'fiverr' },
    { id: 12, name: "ezequiascostrar", country: "Brazil", review: "I always work with him — he delivers at the right time, great professional. I can recommend him because he will do his best to help you.", rating: 5, platform: 'fiverr' },
];

const row2Reviews: Review[] = [
    { id: 13, name: "jemimaolanrewaj", country: "United Kingdom", review: "Great communicator and well knowledgeable in app development and UX. Fast service! He did perfect work, made changes nicely. App wasn't bugged. Definitely recommend.", rating: 5, platform: 'fiverr' },
    { id: 14, name: "user27525667", country: "Canada", review: "Highly skilled, professional, and efficient. Very patient and accommodating, taking time to listen to my needs. The end result exceeded my expectations.", rating: 5, platform: 'fiverr' },
    { id: 15, name: "obaidkhanok02", country: "Pakistan", review: "Best seller. Timely response. Positive, technical and experienced skills. Good to communicate and understands requirements as per customer need. I will suggest giving work to Ameer Hamza.", rating: 5, platform: 'fiverr' },
    { id: 16, name: "Tahir I.", country: "Pakistan", review: "Fantastic work, amazing communication! No doubt one of the best developer. He never gave up and finally got everything to work perfectly. Just amazing.", rating: 5, platform: 'upwork' },
    { id: 17, name: "Touseef A.", country: "Pakistan", review: "The work and communication is excellent. The developer is very concerned and attentive to details. I am very happy with the delivery. We will work together again.", rating: 5, platform: 'upwork' },
    { id: 18, name: "redabaydo", country: "Morocco", review: "I wanted to express my gratitude for the exceptional work. It has been an absolute pleasure to work with someone so talented, dedicated, and committed to delivering high-quality work.", rating: 5, platform: 'fiverr' },
    { id: 19, name: "tanziltonmoy", country: "France", review: "Very satisfied with the communication and the way he helped with everything. Recommended.", rating: 5, platform: 'fiverr' },
    { id: 20, name: "grbook", country: "Sweden", review: "Delivers fast and with good quality. Highly recommended.", rating: 5, platform: 'fiverr' },
    { id: 21, name: "erickkimutai", country: "Kenya", review: "Very professional and dedicated developer. Highly highly recommended. Good Work.", rating: 5, platform: 'fiverr' },
    { id: 22, name: "mekaniel__", country: "Germany", review: "Very good customer service. Very friendly and very good knowledge. 10/10.", rating: 5, platform: 'fiverr' },
    { id: 23, name: "Muhammad B.", country: "Pakistan", review: "Ameer did a great job, very professional, fast response and always delivers on time as per requirements. I will work with him again on next projects.", rating: 5, platform: 'upwork' },
    { id: 24, name: "arajikmarket", country: "Morocco", review: "Happy to work with you again, and definitely would love to do so in future. Delivered at exact time with the best quality.", rating: 5, platform: 'fiverr' },
];

const row3Reviews: Review[] = [
    { id: 25, name: "unboxingst", country: "Algeria", review: "Ameer, you are the one and only app developer I can trust. Your work is amazing. You give me a lot of suggestions that help me develop my first app. Thank you so much!", rating: 5, platform: 'fiverr' },
    { id: 26, name: "ogundatamaster", country: "Nigeria", review: "Ameer did a great job beyond even the task I gave him — fixed every necessary bug in my app. I will surely use him again and again for my app projects. Thank you!", rating: 5, platform: 'fiverr' },
    { id: 27, name: "kavya2224", country: "United States", review: "Excellent work, fast delivery and good explanation.", rating: 5, platform: 'fiverr' },
    { id: 28, name: "apperture", country: "United Kingdom", review: "Great work, fast and great communication.", rating: 5, platform: 'fiverr' },
    { id: 29, name: "idminim", country: "Denmark", review: "He provided the service as I asked and the communication was very good. Revisions were made as I needed. Definitely recommend him!", rating: 5, platform: 'fiverr' },
    { id: 30, name: "ba3241", country: "Saudi Arabia", review: "Very professional work within short time with good skills in programming and solving problems. Fast respond and good person. I will work with him again.", rating: 5, platform: 'fiverr' },
    { id: 31, name: "Usfar A.", country: "Pakistan", review: "He is a very technical person with very good expertise. I definitely recommend him.", rating: 5, platform: 'upwork' },
    { id: 32, name: "jacobdevelop97", country: "South Korea", review: "Constant contact with the developer was able to improve the quality of the app. I was happy to develop my first app with this developer. Thank you sir.", rating: 5, platform: 'fiverr' },
    { id: 33, name: "brutallyhonestc", country: "Cayman Islands", review: "Fantastic work. App was delivered as expected and he even attempted additional ideas post delivery. Would highly recommend and will definitely be using Ameer's services in the future.", rating: 4.7, platform: 'fiverr' },
    { id: 34, name: "devcodemx", country: "Colombia", review: "He works very quickly and understands the requirements that one asks for. I would use his services again.", rating: 5, platform: 'fiverr' },
    { id: 35, name: "ernovels", country: "Dominican Republic", review: "So glad with the seller, very responsible and friendly. I will work with him again. Highly recommended!", rating: 5, platform: 'fiverr' },
    { id: 36, name: "mekastu12", country: "Saudi Arabia", review: "This is my second time, and this is the best seller. He knows what to do and replies within seconds. I highly recommend him for anyone who wants good app development.", rating: 5, platform: 'fiverr' },
];

const StarRating = ({ rating }: { rating: number }) => {
    return (
        <div className="review-stars">
            {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                    key={star}
                    className={star <= Math.round(rating) ? 'star filled' : 'star'}
                />
            ))}
        </div>
    );
};

const PLATFORM_URLS = {
    fiverr: 'https://www.fiverr.com/ameerhamza9990',
    upwork: 'https://www.upwork.com/freelancers/~014f3c0d6719d99dc0?mp_source=share',
};

const ReviewCard = ({ review }: { review: Review }) => (
    <div className="review-card">
        <div className="review-card__header">
            <div className={`review-card__platform review-card__platform--${review.platform}`}>
                {review.platform === 'fiverr' ? <SiFiverr /> : <SiUpwork />}
            </div>
            <div className="review-card__meta">
                <span className="review-card__name">{review.name}</span>
                <span className="review-card__country">📍 {review.country}</span>
            </div>
        </div>
        <StarRating rating={review.rating} />
        <p className="review-card__text">"{review.review}"</p>
        <a
            href={PLATFORM_URLS[review.platform]}
            target="_blank"
            rel="noopener noreferrer"
            className={`review-card__footer review-card__footer--${review.platform}`}
        >
            View on {review.platform === 'fiverr' ? 'Fiverr' : 'Upwork'} →
        </a>
    </div>
);

// Scroll speed in px per 16ms frame — matches the original 60s CSS animation pace
const SCROLL_SPEED = 1.0;
// How long (ms) to wait after user releases before resuming auto-scroll
const RESUME_DELAY = 1200;

const MarqueeRow = ({ reviews, direction }: { reviews: Review[]; direction: 'left' | 'right' }) => {
    const doubled = [...reviews, ...reviews];
    const rowRef = useRef<HTMLDivElement>(null);

    // Drag state kept in refs so they never trigger re-renders
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollStart = useRef(0);
    const isInteracting = useRef(false);
    const animFrameId = useRef(0);
    const resumeTimerId = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        const row = rowRef.current;
        if (!row) return;

        // Initialize scroll position for right-direction rows after layout
        const initFrame = requestAnimationFrame(() => {
            if (direction === 'right' && row.scrollWidth > 0) {
                row.scrollLeft = row.scrollWidth / 2;
            }
        });

        let lastTs: number | null = null;

        const tick = (ts: number) => {
            if (!isInteracting.current) {
                const elapsed = lastTs !== null ? ts - lastTs : 16;
                const delta = SCROLL_SPEED * (elapsed / 16);

                if (direction === 'left') {
                    row.scrollLeft += delta;
                    // When we've scrolled past the first copy, jump back seamlessly
                    if (row.scrollLeft >= row.scrollWidth / 2) {
                        row.scrollLeft -= row.scrollWidth / 2;
                    }
                } else {
                    row.scrollLeft -= delta;
                    // When we've scrolled back past the start, jump to the second copy
                    if (row.scrollLeft <= 0) {
                        row.scrollLeft += row.scrollWidth / 2;
                    }
                }
                lastTs = ts;
            } else {
                lastTs = null; // prevents a big jump when auto-scroll resumes
            }
            animFrameId.current = requestAnimationFrame(tick);
        };

        animFrameId.current = requestAnimationFrame(tick);

        // ── Mobile touch ──────────────────────────────────────────────────
        // Let the browser handle the native horizontal swipe on the element
        // and vertical page scroll simultaneously (it picks based on initial
        // swipe direction). We only need to pause/resume auto-scroll.
        const handleTouchStart = () => {
            isInteracting.current = true;
            if (resumeTimerId.current) clearTimeout(resumeTimerId.current);
        };
        const handleTouchEnd = () => {
            resumeTimerId.current = setTimeout(() => {
                isInteracting.current = false;
            }, RESUME_DELAY);
        };
        row.addEventListener('touchstart', handleTouchStart, { passive: true });
        row.addEventListener('touchend',   handleTouchEnd,   { passive: true });
        row.addEventListener('touchcancel', handleTouchEnd,  { passive: true });

        return () => {
            cancelAnimationFrame(initFrame);
            cancelAnimationFrame(animFrameId.current);
            if (resumeTimerId.current) clearTimeout(resumeTimerId.current);
            row.removeEventListener('touchstart',  handleTouchStart);
            row.removeEventListener('touchend',    handleTouchEnd);
            row.removeEventListener('touchcancel', handleTouchEnd);
        };
    }, [direction]);

    // ── Desktop mouse drag ────────────────────────────────────────────────
    // Guard every handler with pointerType === 'mouse' so touch events never
    // reach setPointerCapture (which would prevent the browser from handling
    // native touch scroll and page scroll simultaneously).
    const onPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
        if (e.pointerType !== 'mouse') return;
        const row = rowRef.current;
        if (!row) return;
        isDragging.current = true;
        isInteracting.current = true;
        startX.current = e.clientX;
        scrollStart.current = row.scrollLeft;
        row.setPointerCapture(e.pointerId);
        if (resumeTimerId.current) clearTimeout(resumeTimerId.current);
    };

    const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
        if (e.pointerType !== 'mouse' || !isDragging.current || !rowRef.current) return;
        rowRef.current.scrollLeft = scrollStart.current - (e.clientX - startX.current);
    };

    const onPointerUp = (e: React.PointerEvent<HTMLDivElement>) => {
        if (e.pointerType !== 'mouse' || !isDragging.current) return;
        isDragging.current = false;
        resumeTimerId.current = setTimeout(() => {
            isInteracting.current = false;
        }, RESUME_DELAY);
    };

    return (
        <div
            className={`marquee-row marquee-row--${direction}`}
            ref={rowRef}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onPointerLeave={onPointerUp}
        >
            <div className="marquee-track">
                {doubled.map((review, index) => (
                    <ReviewCard key={`${review.id}-${index}`} review={review} />
                ))}
            </div>
        </div>
    );
};

function ClientReviews() {
    return (
        <section className="reviews-section" id="reviews">
            <div className="reviews-section__header">
                <div className="reviews-section__header-inner">
                    <h2>What Clients Say</h2>
                    <div className="reviews-section__combined">
                        <span className="reviews-combined__stars">★★★★★</span>
                        <span className="reviews-combined__summary">5.0 · 70+ Reviews · Fiverr & Upwork</span>
                    </div>
                </div>
            </div>

            <div className="marquee-container">
                <MarqueeRow reviews={row1Reviews} direction="left" />
                <MarqueeRow reviews={row2Reviews} direction="right" />
                <MarqueeRow reviews={row3Reviews} direction="left" />
            </div>

            <div className="reviews-section__fade reviews-section__fade--left" />
            <div className="reviews-section__fade reviews-section__fade--right" />
        </section>
    );
}

export default ClientReviews;
